import './index.css';
import React from 'react';
import useTheme from '../../../utilities/hooks/theme';
import Constants from '../../../constants';
import Button from '@mui/material/Button/Button';
import { View, Text } from '../../../component';
import { isSmartPhone } from '../../../utilities/helper';

interface NoContestJoinedProps {
  onPress?: React.MouseEventHandler;
  message?: string;
  buttonLabel?: string;
}
const NoContestJoined = ({ message, buttonLabel, onPress }: NoContestJoinedProps) => {
  const { FantasyTheme: theme } = useTheme();
  const noContestTextColor = {
    color: isSmartPhone ? theme.myJoinedContestNoContestText : '#fff'
  };
  const btnStyle = {
    backgroundColor: isSmartPhone ? theme.myJoinedContestBtn : '#ffc303',
    color: isSmartPhone ? '#fff' : '#000'
  } as React.CSSProperties;
  return (
    <View className="container noContestJoinedWrapper">
      <Constants.Svgs.NoTeamData />
      <Text className="noContestJoinedMessage" style={noContestTextColor}>
        {message}
      </Text>
      <Button style={btnStyle} className="joinedContestBtn" onClick={onPress}>
        {buttonLabel}
      </Button>
    </View>
  );
};
export default React.memo(NoContestJoined);
